import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translationPropType } from '@eb/i18n';

import { SocialLogin } from '@eb/social-login-facebook';

import './checkoutSocialLoginForm.scss';

class CheckoutSocialLoginForm extends React.PureComponent {
    static propTypes = {
        buttonCTA: translationPropType,
        isCheckoutAuthenticationFlow: PropTypes.bool,
        showNotification: PropTypes.func,
        clearNotification: PropTypes.func,
        shouldAnimate: PropTypes.bool,
        socialSSOSettings: PropTypes.shape({
            facebook: PropTypes.object,
        }),
        onFBAccountNotConnected: PropTypes.func,
        onSocialConnectVerified: PropTypes.func,
        onSocialProviderClick: PropTypes.func,
        onGetStartedClick: PropTypes.func,
        onTermsOfServiceClick: PropTypes.func,
        onComunityGuidelinesClick: PropTypes.func,
        onPrivacyPolicyClick: PropTypes.func,
        onSocialButtonLoadComplete: PropTypes.func,
        fp: PropTypes.bool,
    };

    state = {
        isHidden: false,
        isLoading: true,
    };

    componentWillReceiveProps({ submitting, submitFailed, error }) {
        const { showNotification, clearNotification } = this.props;

        /*If the form has an error and submit failed, attempt
        to display a notification*/
        if (submitFailed && error) {
            showNotification(error);
        }

        /*We want to limit only one error notification to
        appear per form submission if the user has dismissed it.
        So each time submitting is true, then reset the flag.*/
        if (submitting) {
            clearNotification();
        }
    }

    componentWillUnmount() {
        const { clearNotification } = this.props;

        clearNotification();
    }

    _handleAccountNotConnected() {
        this.setState({ isHidden: true });

        const { onFBAccountNotConnected } = this.props;
        onFBAccountNotConnected();
    }

    _handleOnLoadComplete() {
        this.setState({ isLoading: false });
    }

    render() {
        const {
            fp,
            isCheckoutAuthenticationFlow,
            onComunityGuidelinesClick,
            onPrivacyPolicyClick,
            onSocialConnectVerified,
            onSocialProviderClick,
            onTermsOfServiceClick,
            onSocialButtonLoadComplete,
            socialSSOSettings,
        } = this.props;

        const buttonClasses = classNames({
            'hide-fb-button': this.state.isHidden || this.state.isLoading,
        });

        return (
            <div className={buttonClasses}>
                <SocialLogin
                    getButtonsOnly={true}
                    isCheckoutAuthenticationFlow={isCheckoutAuthenticationFlow}
                    onNotConnected={this._handleAccountNotConnected.bind(this)}
                    handleOnLoadComplete={this._handleOnLoadComplete.bind(this)}
                    handleOnComponentUpdated={onSocialButtonLoadComplete}
                    onSocialConnectVerified={onSocialConnectVerified}
                    socialSSOSettings={socialSSOSettings}
                    onSocialProviderClick={onSocialProviderClick}
                    onTermsOfServiceClick={onTermsOfServiceClick}
                    onComunityGuidelinesClick={onComunityGuidelinesClick}
                    onPrivacyPolicyClick={onPrivacyPolicyClick}
                    fp={fp}
                />
            </div>
        );
    }
}

export default CheckoutSocialLoginForm;
